import React, { useRef, useEffect, useState } from 'react';
import RadioButton from '../../../../components/Dashboard-res/CommonComponent/RadioButton';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import { useFormikContext } from 'formik';
import CommonDatePicker from '../../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import get from 'lodash/get';
import CommonPincode from '../../../../components/Dashboard-res/CommonComponent/CommonPincode';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import initialImg from '../../../../images/icons/upload_new.svg';
import moment from 'moment';
import PopUp from '../../../../common/components/PopUp/PopUp';
import SavedAccount from './SavedAccount';
import GlobalMonthRangePicker from '../../../../common/components/GlobalMonthPicker/GlobalMonthPicker';
import {
  getBankNameFromIFSC,
  addApplicantBankAccount,
  uploadIncomeBankStatement,
  UploadFileToS3,
  userBankStatementUploaded,
  getApplicantBankAccountDetails,
  userBankAccountUpdate
} from '../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import { GetImgComp } from '../../../../containers/UserKyc/UserKycComponent/UserVoterCard/GetImgComp';
import _ from 'lodash';

let today = new Date();
let sixMonthBack = moment(today)
  .subtract(6, 'months')
  .format('YYYY-MM-DD');

let DocIdCollection = {};
const BankStatement = () => {
  const {
    values,
    data,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched,
    handleSubmit
  } = useFormikContext();
  const [noOfUploadeneeded, setNoOfUploads] = useState('');
  const [steps, setSteps] = useState('showSavedAccountoverView');
  const [show, setShow] = useState(false);
  const [popUpType, setPopUpType] = useState('loading');
  const [popUpText, setPopUpText] = useState('init');

  const [leadId, SetLeadId] = useState(getApplicantionInfo().leadId);
  const [applicantId, setApplicantId] = useState(
    getApplicantionInfo().leadApplicantId
  );
  const [getSavedData, setTogetdata] = useState(
    localStorage.hasOwnProperty('userBankAccountRefId') ? true : false
  );
  const [getSavedlinks, setSavedLinks] = useState([]);
  const [preValues, setPrevAlues] = useState(
    values.preValues ? values.preValues() : ''
  );

  const handleAccountCalues = res => {
    setSteps('showSubmitButton');

    setFieldValue('accountNo', res.accountNumber);
    setFieldValue('ifscCode', res.ifscCode);
    setFieldValue('bankName', res.bankName);
    if (res.links) {
      setSavedLinks(res.links);
      setFieldValue('file', []);
      setFieldValue('imgUrl', []);

      setFieldValue('0', false);
      setFieldValue('1', false);
      setFieldValue('2', false);
      setFieldValue('3', false);
      setFieldValue('4', false);
      setFieldValue('5', false);
      setFieldValue('initialState', false);
      DocIdCollection = {};

      for (let i = 0; i < res.links.length; i++) {
        DocIdCollection[res.links[i].tag] = res.links[i].docId;
      }
    }
  };
  useEffect(() => {
    const setNeededInfo = async () => {
      await SetLeadId(getApplicantionInfo().leadId);
      await setApplicantId(getApplicantionInfo().leadApplicantId);
      setSteps('showSavedAccountoverView');
    };
    if (values.viewAccount()) {
      setNeededInfo();
    }
  }, []);

  useEffect(() => {
    const getTheBankAccountdetails = async () => {
      if (getSavedData && localStorage.hasOwnProperty('userBankAccountRefId')) {
        await setPopUpText('getting bank Account Details...');
        await setPopUpType('loading');
        setShow(true);
        getApplicantBankAccountDetails(
          leadId,
          applicantId,
          localStorage.getItem('userBankAccountRefId')
        )
          .then(async res => {
            if (res.error) {
              throw new Error(res.error.data.message);
            }
            setShow(false);
            handleAccountCalues(res);
            console.log('dsdsnvbvv', res);
          })
          .catch(async err => {
            await setPopUpType(err.toString());
            await setPopUpType('fail');
            setShow(true);
          });
      }
    };
    getTheBankAccountdetails();
  }, [getSavedData]);

  useEffect(
    () => () =>
      localStorage.hasOwnProperty('userBankAccountRefId')
        ? localStorage.removeItem('userBankAccountRefId')
        : null,
    []
  );
  const updatebankAccount = async (leadId, applicantId, body) => {
    userBankAccountUpdate(
      leadId,
      applicantId,
      localStorage.getItem('userBankAccountRefId'),
      body
    )
      .then(async res => {
        if (res.error) {
          throw new Error(res.error.data.message);
        }
        await setPopUpType('success');
        await setPopUpText('Submitted the bank account successfully!');
        await setTimeout(function() {
          setShow(false);
        }, 2000);
        setSteps('showSavedAccountoverView');
      })
      .catch(async err => {
        await setPopUpType('fail');
        await setPopUpText(err.toString());
        setShow(true);
      });
  };

  const saveTheBankAccountDetails = async () => {
    await setPopUpType('loading');
    await setPopUpText('Submitting The Bank Details');
    setShow(true);

    let body = {
      accountNumber: values.accountNo,
      ifscCode: values.ifscCode,
      bankName: values.bankName,
      docIds: Object.values(DocIdCollection)
    };
    if (_.get(preValues, 'step', false) == 'SENP') {
      body['bankAccountType'] = values.accountType;
      body['type'] = 'senp';
    } else {
      body['type'] = 'salaried';
    }
    if (!values.initialState) {
      updatebankAccount(leadId, applicantId, body);
    } else {
      addApplicantBankAccount(leadId, applicantId, body)
        .then(async res => {
          if (res.error) {
            throw new Error(res.error.data.message);
          }
          await setPopUpType('success');
          await setPopUpText('Submitted the bank account successfully!');
          await setTimeout(function() {
            setShow(false);
          }, 2000);
          setSteps('showSavedAccountoverView');
        })
        .catch(async err => {
          await setPopUpType('fail');
          await setPopUpText(err.toString());
          setShow(true);
        });
    }
  };
  return (
    <div className="w-full  mr-auto  block px-5 py-4 bg-white ">
      {steps != 'showSavedAccountoverView' && steps != 'showUploadedFiles' ? (
        <>
          <div className="">
            <p className="font-roboto font-bold text-black-400 text-sm">
              Add Salary account
            </p>
          </div>
          {_.get(preValues, 'step', '') == 'SENP' ? (
            <div className="w-full">
              <GetAccountType
                values={values}
                data={data}
                setData={setData}
                handleChange={handleChange}
                errors={errors}
                touched={touched}
                handleBlur={handleBlur}
                setFieldError={setFieldError}
                setFieldValue={setFieldValue}
                name={name}
                setFileUploadErrors={setFileUploadErrors}
                fileUploadErrors={fileUploadErrors}
                setFieldTouched={setFieldTouched}
                handleSubmit={handleSubmit}
                setSteps={setSteps}
                setPopUpType={setPopUpType}
                setPopUpText={setPopUpText}
                setShow={setShow}
                getSavedData={getSavedData}
              />
            </div>
          ) : null}

          <div className="w-full py-3 my-3">
            <AskForAccountNumber
              values={values}
              data={data}
              setData={setData}
              handleChange={handleChange}
              errors={errors}
              touched={touched}
              handleBlur={handleBlur}
              setFieldError={setFieldError}
              setFieldValue={setFieldValue}
              name={name}
              setFileUploadErrors={setFileUploadErrors}
              fileUploadErrors={fileUploadErrors}
              setFieldTouched={setFieldTouched}
              handleSubmit={handleSubmit}
              setSteps={setSteps}
              setPopUpType={setPopUpType}
              setPopUpText={setPopUpText}
              setShow={setShow}
              getSavedData={getSavedData}
            />
          </div>
          {steps == 'showDetailsOfSatement' ||
          steps == 'showStatementUploadArea' ||
          steps == 'showSubmitButton' ? (
            <div className="w-full my-3 ml-2">
              <UploadBankStatement
                values={values}
                data={data}
                setData={setData}
                handleChange={handleChange}
                errors={errors}
                touched={touched}
                handleBlur={handleBlur}
                setFieldError={setFieldError}
                setFieldValue={setFieldValue}
                name={name}
                setFileUploadErrors={setFileUploadErrors}
                fileUploadErrors={fileUploadErrors}
                setFieldTouched={setFieldTouched}
                handleSubmit={handleSubmit}
                setNoOfUploads={setNoOfUploads}
                setSteps={setSteps}
              />
            </div>
          ) : null}
          {steps == 'showStatementUploadArea' || steps == 'showSubmitButton' ? (
            <div className="w-full py-3 my-3 ml-2">
              <UploadArea
                values={values}
                data={data}
                setData={setData}
                handleChange={handleChange}
                errors={errors}
                touched={touched}
                handleBlur={handleBlur}
                setFieldError={setFieldError}
                setFieldValue={setFieldValue}
                name={name}
                setFileUploadErrors={setFileUploadErrors}
                fileUploadErrors={fileUploadErrors}
                setFieldTouched={setFieldTouched}
                handleSubmit={handleSubmit}
                noOfUploadeneeded={noOfUploadeneeded}
                setSteps={setSteps}
                setPopUpType={setPopUpType}
                setPopUpText={setPopUpText}
                setShow={setShow}
                leadID={leadId}
                applicantId={applicantId}
                getSavedData={getSavedData}
                getSavedlinks={getSavedlinks}
                setTogetdata={setTogetdata}
              />
            </div>
          ) : null}
          {steps == 'showSubmitButton' ? (
            <PageButton
              setSteps={setSteps}
              onclik={saveTheBankAccountDetails}
            />
          ) : null}
        </>
      ) : null}

      {steps == 'showSavedAccountoverView' ? (
        <div className="w-full">
          <SavedAccount
            setSteps={setSteps}
            values={values}
            setFieldValue={setFieldValue}
            leadId={leadId}
            applicantId={applicantId}
            setPopUpType={e => setPopUpType(e)}
            setPopUpText={e => setPopUpText(e)}
            setShow={e => setShow(e)}
            setTogetdata={e => setTogetdata(e)}
            preValues={preValues}
            setFieldTouched={setFieldTouched}
          />
          <button
            type="button"
            className="submitButton font-roboto text-white text-base w-48 my-0 clear-both mt-2 "
            onClick={async () => {
              await setFieldValue('addNewAccount', false);
              handleSubmit();
            }}
          >
            NEXT
          </button>
        </div>
      ) : null}

      <PopUp type={popUpType} text={popUpText} setShow={setShow} show={show} />
    </div>
  );
};

const AskForAccountNumber = props => {
  const {
    values,
    data,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched,
    handleSubmit,
    setSteps,
    setPopUpType,
    setPopUpText,
    setShow,
    getSavedData
  } = props;

  const getBankName = async () => {
    if (!getSavedData) {
      if (
        !errors.ifscCode &&
        values.ifscCode.length == 11 &&
        !errors.accountNo
      ) {
        await setPopUpType('loading');

        await setPopUpText(
          <p>
            Getting Bank Information
            <br />
            Please Wait
          </p>
        );
        setShow(true);
        getBankNameFromIFSC(values.ifscCode)
          .then(async res => {
            if (res.error) {
              throw new Error(res);
            }
            if (res.BANK) {
              setShow(false);
              setSteps('showDetailsOfSatement');
              setFieldValue('bankName', res.BANK.toString());
              setFieldValue('statementType', '');
            } else {
              await setPopUpText(
                <p>
                  Not Able to Find Bank Information Please Check your details
                </p>
              );
              await setPopUpType('fail');
              setSteps('initialState');
              setFieldValue('bankName', '');
            }
          })
          .catch(async err => {
            await setPopUpText(
              <p>Not Able to Find Bank Information Please Check your details</p>
            );
            await setPopUpType('fail');
            setSteps('initialState');
            setFieldValue('statementType', '');
            setFieldValue('bankName', '');
          });
      }
    }
  };

  useEffect(() => {
    getBankName();
  }, [values.ifscCode, errors.ifscCode, errors.accountNo]);

  return (
    <div className="w-full mx-auto px-2">
      <div className="w-full flex flex-wrap">
        <div className="w-full md:w-64 mx-2 mt-3">
          <CommonInput
            name="accountNo"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.accountNo}
            legendName="Account Number"
            error={touched.accountNo && errors.accountNo}
            errorMsg={errors.accountNo}
            touched={touched.accountNo}
          />
        </div>
        <div className="w-full md:w-64 mx-2 mt-3">
          <CommonInput
            name="ifscCode"
            onChange={e =>
              e.target.value.length <= 11 ? handleChange(e) : null
            }
            onBlur={handleBlur}
            value={values.ifscCode}
            legendName="IFSC Code"
            error={touched.ifscCode && errors.ifscCode}
            errorMsg={errors.ifscCode}
            touched={touched.ifscCode}
          />
        </div>
      </div>
      <div className="mr-auto flex my-2 mx-1">
        <p className="font-roboto font-normal text-sm text-black-500 ml-1">
          {' '}
          {values.bankName}
        </p>
      </div>
    </div>
  );
};

const UploadBankStatement = props => {
  const {
    values,
    data,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched,
    handleSubmit,
    setNoOfUploads,
    setSteps
  } = props;

  return (
    <div className="w-full">
      <p className="mr-auto font-roboto font-bold text-black-400 text-sm">
        Upload Bank Statement
      </p>
      <div className="w-full flex  my-4">
        <div className="ml-3 flex">
          <RadioButton
            name="statementType"
            value={values.statementType == 'consolidated' ? true : false}
            checked={values.statementType == 'consolidated' ? true : false}
            onChange={e => {
              handleChange(e),
                setFieldValue('statementType', 'consolidated'),
                setNoOfUploads(1),
                setSteps('showStatementUploadArea');
            }}
            onBlur={handleBlur}
          />
          <p className="font-roboto font-normal text-sm text-black-400 ml-2 ">
            Consolidated Statement
          </p>
        </div>
        <div className="mr-auto ml-4 flex">
          <RadioButton
            name="statementType"
            value={values.statementType == 'individual' ? true : false}
            checked={values.statementType == 'individual' ? true : false}
            onChange={e => {
              handleChange(e),
                setFieldValue('statementType', 'individual'),
                setNoOfUploads(6);
              setSteps('showStatementUploadArea');
            }}
            onBlur={handleBlur}
          />
          <p className="font-roboto font-normal text-sm text-black-400 ml-2 mr-auto">
            Individual Statement
          </p>
        </div>
      </div>
    </div>
  );
};

const UploadArea = props => {
  const {
    values,
    data,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched,
    handleSubmit,
    noOfUploadeneeded,
    setSteps,
    setPopUpType,
    setPopUpText,
    setShow,
    leadID,
    applicantId,
    getSavedData,
    getSavedlinks,
    setTogetdata
  } = props;

  const UploadComp = useRef('');
  const [uploadCompo, setUploadCompo] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [ShowStep, setShowSteps] = useState('');

  const [rangeValue, setRangeValue] = useState({
    from: {
      year: parseInt(moment(sixMonthBack).year()),
      month: parseInt(moment(sixMonthBack).month() + 1)
    },
    to: {
      year: parseInt(moment(today).year()),
      month: parseInt(moment(today).month())
    }
  });

  const GetMonthRangeDescriber = () => {
    if (rangeValue && noOfUploadeneeded) {
      let startMonth = rangeValue.from.month,
        startYear = rangeValue.from.year,
        endMonth = rangeValue.to.month,
        endYear = rangeValue.to.year;
      setFieldValue('initialState', true);
      setUploadCompo(
        Array.from({ length: noOfUploadeneeded }, (x, i) => {
          let month = parseInt(startMonth) + i;
          let year = parseInt(startYear);
          if (noOfUploadeneeded != 1) {
            if (month > 12) {
              year = parseInt(year) + 1;
              return {
                month: `${moment((month - 12).toString(), 'MM').format(
                  'MMMM'
                )}-${year}`
              };
            }
            return {
              month: `${moment(month.toString(), 'MM').format('MMMM')}-${year}`
            };
          } else {
            return {
              month: `${moment(month.toString(), 'MM').format(
                'MMMM'
              )}-${year} to ${moment(endMonth.toString(), 'MM').format(
                'MMMM'
              )}-${endYear}`
            };
          }
        })
      );
    }
  };

  useEffect(() => {
    if (noOfUploadeneeded) {
      setShowSteps('showuptoUploadArea');
    }
  }, [noOfUploadeneeded]);

  useEffect(() => {
    let startMonth = rangeValue.from.month,
      startYearInMonth = parseInt(rangeValue.from.year) * 12,
      endMonth = rangeValue.to.month,
      endYearInMonth = parseInt(rangeValue.to.year) * 12;
    if (endYearInMonth + endMonth - (startYearInMonth + startMonth) + 1 >= 6) {
      GetMonthRangeDescriber();
      setShowSteps('showuptoUploadArea');
    } else {
      const MessagePopUp = async () => {
        await setPopUpType('fail');
        await setPopUpText(
          <p>
            Please slect 6 months Span <br /> You Selected Month range of{' '}
            {endYearInMonth + endMonth - (startYearInMonth + startMonth) + 1}{' '}
          </p>
        );
        setShow(true);
        setShowSteps('showuptoDatePicker');
      };
      MessagePopUp();
    }
  }, [rangeValue, noOfUploadeneeded]);

  const giveFeeedbckOnUploaddedFile = async (docId, tag) => {
    userBankStatementUploaded(leadID, applicantId, docId)
      .then(async res => {
        if (res.error) {
          throw new Error(res.error.data.message);
        }

        await setPopUpType('success');
        await setPopUpText('File is uploaded Successfully! ');
        DocIdCollection[tag.toString()] = parseInt(docId);
        setTimeout(function() {
          setShow(false);
        }, 2000);
      })
      .catch(async err => {
        await setPopUpType('fail');
        await setPopUpText(err.toString());
        setShow(true);
      });
  };

  const uploadFileT0S3FromS3Url = async (res, file, tag) => {
    if (res.url && res.requestId) {
      UploadFileToS3(res.url, file)
        .then(async response => {
          if (response.error) {
            throw new Error(response.error);
          }
          await giveFeeedbckOnUploaddedFile(res.requestId, tag);
        })
        .catch(async uploadError => {
          await setPopUpType('fail');
          await setPopUpText(uploadError.toString());
          setShow(true);
        });
    } else {
      throw new Error("Can't able to upload the file");
    }
  };

  const UploadFile = async index => {
    if (!getSavedData) {
      let tag, file;
      if (values.initialState) {
        tag = uploadCompo[index].month;
      } else {
        tag = values[index.toString() + 'value'];
      }

      file = values.file[index][0];
      await setPopUpType('loading');
      await setPopUpText('File is uploading.... ');
      setShow(true);
      uploadIncomeBankStatement(leadID, applicantId, tag)
        .then(async res => {
          if (res.error) {
            throw new Error(res.error.data.message);
          }
          await uploadFileT0S3FromS3Url(res, file, tag);
        })
        .catch(async err => {
          await setPopUpType('fail');
          await setPopUpText(err.toString());
          setShow(true);
        });
    }
  };

  useEffect(() => {
    if (
      values.file[0] ||
      values.file[1] ||
      values.file[2] ||
      values.file[3] ||
      values.file[4] ||
      values.file[5]
    ) {
      setSteps('showSubmitButton');
    }
  }, [
    values.file[0],
    values.file[1],
    values.file[2],
    values.file[3],
    values.file[4],
    values.file[5]
  ]);

  useEffect(() => {
    if (values.file[0] && values.file[0][0]) {
      UploadFile(0);
    }
  }, [values.file[0]]);

  useEffect(() => {
    if (values.file[1] && values.file[1][0]) {
      UploadFile(1);
    }
  }, [values.file[1]]);

  useEffect(() => {
    if (values.file[2] && values.file[2][0]) {
      UploadFile(2);
    }
  }, [values.file[2]]);

  useEffect(() => {
    if (values.file[3] && values.file[3][0]) {
      UploadFile(3);
    }
  }, [values.file[3]]);

  useEffect(() => {
    if (values.file[4] && values.file[4][0]) {
      UploadFile(4);
    }
  }, [values.file[4]]);

  useEffect(() => {
    if (values.file[5] && values.file[5][0]) {
      UploadFile(5);
    }
  }, [values.file[5]]);

  return (
    <div className="w-full block">
      {ShowStep == 'showuptoDatePicker' || ShowStep == 'showuptoUploadArea' ? (
        <>
          <p className="font-roboto font-normal text-black-500 text-sm">
            Please upload last 6 month bank statement
          </p>
          <div className=" flex">
            <GlobalMonthRangePicker
              rangeValue={rangeValue}
              setRangeValue={setRangeValue}
              validRange={{
                min: {
                  year: parseInt(moment(today).year()) - 1,
                  month: parseInt(moment(today).month())
                },
                max: {
                  year: parseInt(moment(today).year()),
                  month: parseInt(moment(today).month())
                }
              }} //{min: 2013}
              styleObject={{ minWidth: '200px' }}
            />
          </div>
        </>
      ) : null}
      {ShowStep == 'showuptoUploadArea' ? (
        <div className="w-full">
          <div
            className="mr-auto flex flex-wrap my-4  uploadComponent "
            ref={UploadComp}
          >
            {getSavedlinks.length > 0
              ? getSavedlinks.map((each, index) => {
                  if (!values[index.toString()]) {
                    return (
                      <GetImgComp
                        imgUrl={each.url}
                        setEdit={e => {
                          setTogetdata(false),
                            setFieldValue(index.toString() + 'value', each.tag),
                            setFieldValue(index.toString(), e);
                        }}
                      />
                    );
                  } else {
                    return (
                      <GlobalUploadComp
                        data={values}
                        imgIndex={parseInt(index)} //0,1,2,3 depending upon the no of file sequence
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        setFieldError={setFieldError}
                        initialImg={initialImg} // initial image
                        subInst="Click here to upload"
                        subtext="CHOOSE FILE"
                        headerText={
                          <p className="text-center mt-1 text-black-500">
                            {each.tag}
                          </p>
                        }
                      />
                    );
                  }
                })
              : uploadCompo.map((each, index) => (
                  <div className="m-2">
                    <GlobalUploadComp
                      data={values}
                      imgIndex={parseInt(index)} //0,1,2,3 depending upon the no of file sequence
                      errors={errors}
                      touched={touched}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      setFieldError={setFieldError}
                      initialImg={initialImg} // initial image
                      subInst="Click here to upload"
                      subtext="CHOOSE FILE"
                      headerText={
                        <p className="text-center mt-1 text-black-500">
                          {each.month}
                        </p>
                      }
                    />
                  </div>
                ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

const PageButton = props => {
  const { setSteps, onclik } = props;
  const onCancelClick = () => {
    setSteps('showSavedAccountoverView');
  };
  return (
    <div
      className="w-full flex items-center h-20 mx-auto"
      style={{ width: 'fit-content' }}
    >
      <button
        type="button"
        className="bg-white border border-black-500 font-roboto text-black-500  py-2  rounded  text-base w-48 mt-8"
        onClick={onCancelClick}
      >
        Cancel
      </button>
      <button
        type="button"
        className="submitButton font-roboto text-white text-base w-48 my-0 "
        style={{ marginLeft: '10px', marginRight: '10px' }}
        onClick={() => {
          onclik();
        }}
      >
        Add
      </button>
    </div>
  );
};

export default BankStatement;

const GetAccountType = ({
  values,
  data,
  setData,
  handleChange,
  errors,
  touched,
  handleBlur,
  setFieldError,
  setFieldValue,
  name,
  setFileUploadErrors,
  fileUploadErrors,
  setFieldTouched,
  handleSubmit,
  setNoOfUploads,
  setSteps
}) => {
  const handleOnChange = value => {
    setFieldValue('accountType', value);
  };
  return (
    <div className="w-full mt-5">
      <p className="text-black-500 font-roboto font-medium text-sm ">
        {' '}
        Type Of Account{' '}
      </p>
      <div className="w-full md:flex block my-4  md:px-0">
        <div className="mr-auto md:mr-2 md:ml-0 ml-2 my-3 md:my-0 flex md:flex-row flex-row-reverse">
          <RadioButton
            name="accountType"
            value={values.accountType == 'current' ? true : false}
            checked={values.accountType == 'current' ? true : false}
            onChange={() => handleOnChange('current')}
            onBlur={handleBlur}
          />

          <p className="font-roboto font-normal text-sm text-black-500 ml-2 mr-auto">
            Current
          </p>
        </div>
        <div className="mr-auto ml-2 flex md:flex-row flex-row-reverse">
          <RadioButton
            name="accountType"
            value={values.accountType == 'saving' ? true : false}
            checked={values.accountType == 'saving' ? true : false}
            onChange={() => handleOnChange('saving')}
            onBlur={handleBlur}
          />
          <p className="font-roboto font-normal text-sm text-black-500 ml-2 mr-auto">
            Saving
          </p>
        </div>
      </div>
    </div>
  );
};
